export const SITE_DASHBOARD_LISTING = "SITE_DASHBOARD_LISTING";
export const SITE_DETAIL = "SITE_DETAIL";
export const SITE_DASHBOARD_EXPORT_CSV = "SITE_DASHBOARD_EXPORT_CSV";
